<template>
  <div class="wrapper">
    <!-- style="min-height: 436px" -->
    <div id="formContent" class="relative">
      <!-- Loading Spinner -->
      <div
        class="d-flex justify-content-center align-items-center"
        style="height: 360px"
        v-if="loading"
      >
        <BSpinner v-if="loading" variant="primary" label="Large Spinner" />
      </div>
      <!-- Form Content -->
      <div @keyup.enter="loginMethod" v-else>
        <!-- Tabs Titles -->
        <h5 class="text-center mt-3">Login</h5>
        <!-- Icon -->
        <div>
          <i class="bi bi-person-circle" style="color: #0a80e5ad"></i>
        </div>
        <!-- Login Form -->
        <div class="form-group d-flex flex-column align-items-center">
          <input
            required
            type="text"
            id="login"
            name="email"
            placeholder="Email Address"
            v-model="form.email"
          />
          <span
            class="text-danger animate__animated animate__headShake"
            v-if="errors.email"
          >
            {{ errors.email[0] }}
          </span>
        </div>
        <div
          class="form-group d-flex position-relative flex-column align-items-center"
        >
          <input
            type="password"
            id="password"
            name="passw"
            placeholder="Password"
            v-model="form.password"
          />
          <i
            v-if="!shwPassw"
            @click="shwPassw = !shwPassw"
            class="bi-eye-fill eye-icon"
          ></i>
          <i
            v-else
            @click="shwPassw = !shwPassw"
            class="bi-eye-slash-fill eye-icon"
          ></i>
          <span
            class="text-danger animate__animated animate__headShake"
            v-if="errors.password"
          >
            {{ errors.password[0] }}
          </span>
        </div>
        <button type="submit" value="Log In" @click.prevent="loginMethod">
          Log In
        </button>
        <div></div>
      </div>
    </div>
  </div>
</template>

<script>
// import User from "../apis/User";
import { mapActions } from "vuex";
import { BSpinner } from "bootstrap-vue";

export default {
  name: "Login",
  components: {
    BSpinner,
  },
  data() {
    return {
      form: {
        email: "",
        password: "",
      },
      loading: false,
      shwPassw: false,
      errors: [],
    };
  },
  methods: {
    ...mapActions(["login"]),
    loginMethod() {
      this.loading = true;

      this.login(this.form)
        .then((response) => {
          //this.$root.$emit("login", true);
          localStorage.setItem("auth", "true");

          this.$router
            .push({
              path:
                this.$route.query.redirect !== undefined
                  ? this.$route.query.redirect
                  : "/dashboard",
            })
            .catch(() => {});

          this.loading = false;
        })
        .catch((error) => {
          if (error.response.status === 422) {
            this.loading = false;
            this.errors = error.response.data.errors;
          }
        });
    },
  },
  watch: {
    shwPassw() {
      let password = document.querySelectorAll("input[name='passw']")[0];
      let type =
        password.getAttribute("type") === "password" ? "text" : "password";

      password.setAttribute("type", type);
    },
  },
};
</script>

<style scoped>
/* BASIC */
html {
  background-color: #56baed;
}
body {
  font-family: "Poppins", sans-serif;
  height: 100vh;
}
a {
  color: #92badd;
  display: inline-block;
  text-decoration: none;
  font-weight: 400;
}
h2 {
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  text-transform: uppercase;
  display: inline-block;
  margin: 40px 8px 10px 8px;
  color: #cccccc;
}
/* STRUCTURE */
.wrapper {
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;
  width: 100%;
  min-height: 100%;
  padding: 20px;
  top: -50px;
}
#formContent {
  -webkit-border-radius: 10px 10px 10px 10px;
  border-radius: 10px 10px 10px 10px;
  background: #fff;
  padding: 30px;
  width: 90%;
  max-width: 450px;
  position: relative;
  padding: 0px;
  -webkit-box-shadow: 0 30px 60px 0 rgba(0, 0, 0, 0.3);
  box-shadow: 0 30px 60px 0 rgba(0, 0, 0, 0.3);
  text-align: center;
}
#formFooter {
  background-color: #f6f6f6;
  border-top: 1px solid #dce8f1;
  padding: 25px;
  text-align: center;
  -webkit-border-radius: 0 0 10px 10px;
  border-radius: 0 0 10px 10px;
}
/* TABS */
h2.inactive {
  color: #cccccc;
}
h2.active {
  color: #0d0d0d;
  border-bottom: 2px solid #0a80e5;
}
/* FORM TYPOGRAPHY*/
input[type="button"],
button,
input[type="reset"] {
  background-color: #0a80e5;
  border: none;
  color: white;
  padding: 15px 80px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  text-transform: uppercase;
  font-size: 13px;
  -webkit-box-shadow: 0 10px 30px 0 rgba(95, 186, 233, 0.4);
  box-shadow: 0 10px 30px 0 rgba(95, 186, 233, 0.4);
  -webkit-border-radius: 5px 5px 5px 5px;
  border-radius: 5px 5px 5px 5px;
  margin: 5px 20px 40px 20px;
  -webkit-transition: all 0.3s ease-in-out;
  -moz-transition: all 0.3s ease-in-out;
  -ms-transition: all 0.3s ease-in-out;
  -o-transition: all 0.3s ease-in-out;
  transition: all 0.3s ease-in-out;
}
input[type="button"]:hover,
button:hover,
input[type="reset"]:hover {
  background-color: #0a89f8cb;
}
input[type="button"]:active,
button:active,
input[type="reset"]:active {
  -moz-transform: scale(0.95);
  -webkit-transform: scale(0.95);
  -o-transform: scale(0.95);
  -ms-transform: scale(0.95);
  transform: scale(0.95);
}
input[type="text"],
input[type="password"] {
  background-color: #f6f6f6;
  border: none;
  color: #0d0d0d;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 5px;
  width: 85%;
  border: 2px solid #f6f6f6;
  -webkit-transition: all 0.5s ease-in-out;
  -moz-transition: all 0.5s ease-in-out;
  -ms-transition: all 0.5s ease-in-out;
  -o-transition: all 0.5s ease-in-out;
  transition: all 0.5s ease-in-out;
  -webkit-border-radius: 5px 5px 5px 5px;
  border-radius: 5px 5px 5px 5px;
}
input[type="text"]:focus,
input[type="password"]:focus {
  background-color: #fff;
  border-bottom: 2px solid #0a80e5;
}
input[type="text"]::placeholder,
input[type="password"]::placeholder {
  color: #cccccc;
}
/* ANIMATIONS */
/* Simple CSS3 Fade-in-down Animation */
.fadeInDown {
  -webkit-animation-name: fadeInDown;
  animation-name: fadeInDown;
  -webkit-animation-duration: 1s;
  animation-duration: 1s;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
}
@-webkit-keyframes fadeInDown {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}
@keyframes fadeInDown {
  0% {
    opacity: 0;
    -webkit-transform: translate3d(0, -100%, 0);
    transform: translate3d(0, -100%, 0);
  }
  100% {
    opacity: 1;
    -webkit-transform: none;
    transform: none;
  }
}
/* Simple CSS3 Fade-in Animation */
@-webkit-keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@-moz-keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
.fadeIn {
  opacity: 0;
  -webkit-animation: fadeIn ease-in 1;
  -moz-animation: fadeIn ease-in 1;
  animation: fadeIn ease-in 1;

  -webkit-animation-fill-mode: forwards;
  -moz-animation-fill-mode: forwards;
  animation-fill-mode: forwards;

  -webkit-animation-duration: 1s;
  -moz-animation-duration: 1s;
  animation-duration: 1s;
}
.first {
  -webkit-animation-delay: 0.4s;
  -moz-animation-delay: 0.4s;
  animation-delay: 0.4s;
}
.second {
  -webkit-animation-delay: 0.6s;
  -moz-animation-delay: 0.6s;
  animation-delay: 0.6s;
}
.third {
  -webkit-animation-delay: 0.8s;
  -moz-animation-delay: 0.8s;
  animation-delay: 0.8s;
}
.fourth {
  -webkit-animation-delay: 1s;
  -moz-animation-delay: 1s;
  animation-delay: 1s;
}
.fifth {
  -webkit-animation-delay: 1.2s;
  -moz-animation-delay: 1.2s;
  animation-delay: 1.2s;
}
/* OTHERS */
*:focus {
  outline: none;
}
#icon {
  width: 60%;
}
.center {
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
.eye-icon {
  position: absolute;
  display: flex;
  justify-content: end;
  height: 100%;
  align-items: center;
  font-size: 20px;
  color: #59a9ed;
  cursor: pointer;
  right: 60px;
}
.eye-icon:hover {
  color: #0a80e5;
}
@media (max-width: 500px) {
  .wrapper.fadeInDown {
    display: flex;
    justify-content: inherit;
  }
}
</style>
